import FolderOutlinedIcon from '@mui/icons-material/FolderOutlined';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import { Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { capitalizeAndKeepTheRest } from 'helpers/helpers';
import { translateBlock } from 'i18n';
import routes from 'modules/datacatalog/routes';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import DomainIcon from '../../CatalogTree/components/DomainIcon';

const Breadcrumb = ({
    domain,
    category,
    table = '',
}: {
    domain: string;
    category: string;
    table?: string;
}) => {
    const { t } = useTranslation();
    const domainLabel = t(`dataCatalog.${domain.toLowerCase()}`);
    const categoryLabel =
        category !== 'unclassified'
            ? translateBlock(`${domain.toLowerCase()}.${category}`)
            : null;
    const tableLabel =
        table && table !== 'other' ? translateBlock(table) : null;

    return (
        <Stack
            direction="row"
            spacing={0.5}
            sx={{
                alignItems: 'center',
                flexWrap: 'wrap',
            }}
        >
            <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
                <DomainIcon domain={domain} color="text.secondary" />
                <Typography variant="caption" color="textSecondary">
                    {capitalizeAndKeepTheRest(domainLabel)}
                </Typography>
            </Stack>
            {categoryLabel && (
                <>
                    <Typography variant="caption" color="textDisabled">
                        ›
                    </Typography>
                    <Stack
                        direction="row"
                        spacing={0.5}
                        sx={{ alignItems: 'center' }}
                    >
                        <FolderOutlinedIcon
                            sx={{ fontSize: '0.8rem', color: 'text.disabled' }}
                        />
                        <Typography variant="caption" color="textSecondary">
                            {capitalizeAndKeepTheRest(categoryLabel)}
                        </Typography>
                    </Stack>
                </>
            )}
            {tableLabel && (
                <>
                    <Typography variant="caption" color="textDisabled">
                        ›
                    </Typography>
                    <Stack
                        component={Link}
                        to={`${routes.dataCatalog}?field=${table}`}
                        direction="row"
                        spacing={0.5}
                        sx={{
                            alignItems: 'center',
                            textDecoration: 'none',
                        }}
                    >
                        <TableChartOutlinedIcon
                            sx={{ fontSize: '0.8rem' }}
                            color="primary"
                        />
                        <Typography variant="caption" color="primary">
                            {capitalizeAndKeepTheRest(tableLabel)}
                        </Typography>
                    </Stack>
                </>
            )}
        </Stack>
    );
};

export default Breadcrumb;
